import styled from "@emotion/styled";
import { Flex, Popover, TextField } from "@radix-ui/themes";

import { Image, Text } from "@src/ui-kit";
import { theme } from "@themes/themes";

export const MarketSelectButton = styled.button`
  all: unset;

  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    background-color: ${theme.color("white-20")};
    border-radius: 4px;
  }
`;

export const TokenIcon = styled(Image)`
  width: 24px;
  height: 24px;
  border-radius: 100%;
`;

export const TokenIconSmall = styled(Image)`
  width: 20px;
  height: 20px;
  border-radius: 100%;
`;

export const TokenSymbolText = styled.span`
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: 0;
`;

export const PopoverContent = styled(Popover.Content)`
  --max-width: none;
  width: 720px;
  max-width: none !important;
  height: auto;
  min-height: 300px;
  max-height: 500px;
  border-radius: 12px;
  padding: 16px;

  background-color: ${theme.color("gray-2")};

  border: 1px solid ${theme.color("gray-5")};

  box-shadow:
    0px 4px 20px 0px #00000080,
    1px 1px 2px 0px #00000040;

  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const StickyHeader = styled.div`
  display: grid;
  grid-template-columns: 130px 140px 80px 100px 105px 70px;
  align-items: center;
  padding: 8px 0;
  gap: 12px;
  min-width: max-content;
  position: sticky;
  top: 0;
  background-color: ${theme.color("gray-2")};
  z-index: 2;
  border-bottom: 1px solid ${theme.color("gray-5")};
`;

export const HeaderMarketCell = styled(Text)`
  ${theme.font.body12};
  color: ${theme.color("gray-11")};
  position: sticky;
  left: 0;
  background-color: ${theme.color("gray-2")};
  z-index: 3;
  padding: 5px 0px 5px 8px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 130px 140px 80px 100px 105px 70px;
  align-items: center;
  padding: 8px 0;
  gap: 12px;
  min-width: max-content;

  cursor: pointer;

  &:hover {
    background-color: ${theme.color("gray-4")};
  }

  &:not(:last-of-type) {
    border-bottom: 1px solid ${theme.color("gray-5")};
  }
`;

export const ScrollContainer = styled.div`
  overflow: auto;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const TitleText = styled(Text)`
  ${theme.font.body12};
  color: ${theme.color("gray-11")};
`;

export const MonoText = styled(Text)`
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.24px;
  color: ${theme.color("accent-contrast")};
  text-wrap: nowrap;
`;

export const MarketCell = styled(Flex)`
  align-items: center;
  gap: 6px;
  position: sticky;
  left: 0;
  background-color: ${theme.color("gray-2")};
  z-index: 1;
  padding-right: 8px;

  ${Row}:hover & {
    background-color: ${theme.color("gray-4")};
  }
`;

export const TokenName = styled.span`
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: ${theme.color("accent-contrast")};
`;

export const ChangeCell = styled(Flex)<{ type: "bid" | "ask" | "neutral" }>`
  align-items: center;
  gap: 2px;
  color: ${({ type }) =>
    type === "bid" ? theme.color("green-strong") : type === "ask" ? theme.color("red-strong") : theme.color("gray-11")};
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.24px;
`;

export const FundingRateText = styled(Text)<{ direction: "positive" | "negative" }>`
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.24px;
  color: ${({ direction }) => (direction === "positive" ? theme.color("green-strong") : theme.color("red-strong"))};
  text-wrap: nowrap;
`;

export const MarginBadgeContainer = styled(Flex)`
  align-items: center;
  padding: 1px 4px;
  background-color: ${theme.color("gray-4")};
  border: 1px solid ${theme.color("gray-5")};
  border-radius: 2px;
`;

export const MarginBadgeText = styled.span`
  ${theme.font.support10};
  color: ${theme.color("accent-contrast")};
`;

export const StyledInput = styled(TextField.Root)`
  flex: 1;
  box-shadow: inset 0 0 0 var(--text-field-border-width) ${theme.color("gray-5")};
  &::placeholder {
    color: ${theme.color("gray-8")};
  }
`;

export const SheetContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
  gap: 8px;
`;

export const FavoriteIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  cursor: pointer;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  cursor: pointer;
`;
